import { Navigate } from 'react-router-dom';

const Users = () => <Navigate to="/settings?tab=users" replace />;

export default Users;
